module.exports = __webpack_public_path__ + "img/logo_1.4de9d953.png";